<template>
    <div class="board__search" >
        <label class="board__input">
            <input type="text" id="Search_doc" placeholder="센터,의료진,질환으로 검색해주세요." v-model="searchKeyword" @keyup.enter="searchDoctor">
            <button type="button" class="board__input-btn" @click="searchDoctor"></button>
        </label>
        <!-- active -->
        <div class="dimmed" :class="{active: searchDoctorLayer}" @click.stop="searchDoctorLayer = false">
            <div class="dimmed__inner">
                <ul class="doctor-list" @click.stop>
                    <li class="doctor-list__item" v-for="(doctor, idx) in searchDoctorList" :key="idx">
                        <div class="doctor-list&#45;&#45;img">
                            <img :src="`/displayFile.do?drSid=${doctor.drSid}`" alt="이미지" onerror="this.style.display='none'">
                        </div>
                        <div class="doctor-list&#45;&#45;con">
                            <div class="doctor-list&#45;&#45;text">
                                <h3 class="doctor-list&#45;&#45;name">{{ doctor.name }} 교수</h3>
                                <p class="doctor-list&#45;&#45;department">{{ doctor.belong }}</p>

                                <h4 class="doctor-list&#45;&#45;clinic"  v-if="doctor.detailField">전문진료분야</h4>
                                <p class="doctor-list&#45;&#45;desc">{{ doctor.detailField }}</p>
                            </div>
                            <div class="doctor-list&#45;&#45;button">
                                <a href="javascript:;" @click="selectDoctorSearch(doctor)">해당 의료진 선택</a>
                                <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.mainDeptCd}`" target="_blank">의료진 소개</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="reservation" :class="{active: this.quickReservationActive}">
        <div class="reservation__box" ref="step01">
            <div class="step step1">
                <div class="top" @click="goStep(1)">
                    <h4>step01</h4>
                    <img src="@/assets/resource/icon/arrow_btn.svg" alt="">
                    <span>{{selectedDept.deptNm || '센터'}}</span>
                </div>
                <div class="step1__list-wrap">
                    <div class="step1__list__teb" v-if="$store.getters.getHost === 'H0009'">
                        <a href="javascript:;" :class="{'step1__list__tab--item': true, 'active': viewType == 'center'}" @click="viewType = 'center'">센터</a>
                        <a href="javascript:;" :class="{'step1__list__tab--item': true, 'active': viewType == 'clinic'}" @click="viewType = 'clinic'">클리닉</a>
                    </div>
                    <ul :class="{'step1__list': true, 'body': true, 'active': step == 1}">
                        <li class="step1__item" v-for="(department, idx) in departmentList[viewType]" :key="idx">
                            <div class="tit">{{ department.deptNm }}</div>
                            <div class="btn">
                                <!-- 선택시 active -->
                                <button type="button" :class="{active: (department.deptCd == selectedDept.deptCd && !quickReservationActive) || (department.deptCd == hoverDept.deptCd && !hoverReservationActive)}" 
                                    @click="normalReservation(department)"
                                    @mouseover="hoverActive(department, false)" @mouseleave="hoverActive({}, false)">진료예약</button>
                                <button type="button" :class="{active: (department.deptCd == selectedDept.deptCd && quickReservationActive) || (department.deptCd == hoverDept.deptCd && hoverReservationActive)}" 
                                    @click="quickReservation(department)"
                                    @mouseover="hoverActive(department, true)" @mouseleave="hoverActive({}, true)">빠른예약</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="reservation__box">
            <div class="step step2" ref="step02">
                <div class="top" @click="[goStep(2), step02Active = true]">
                    <h4>step02</h4>
                    <img src="@/assets/resource/icon/arrow_btn.svg" alt="">
                    <span>{{selectedDoctor.name || '담당 의료진'}}</span>
                </div>
                <div :class="{'body': true, 'active': step == 2 && step02Active}" v-if="step > 1">
                    <div class="reservation__check">
                        <div class="checkbox-wrap">
                            <label><input type="radio" name="test-check01" v-model="sortCheck" value="rsvDate" @click="sortOrder('rsvDate')"><span class="checkbox-btn"></span>
                                <p>예약빠른순</p>
                            </label>
                        </div>
                        <div class="checkbox-wrap">
                            <label><input type="radio" name="test-check01" v-model="sortCheck" value="name" @click="sortOrder('name')"><span class="checkbox-btn"></span>
                                <p>가나다순</p>
                            </label>
                        </div>
                    </div>

                    <!-- v-if doctor-list -->
                    <ul class="doctor-list">
                        <li class="doctor-list__item" v-for="(doctor, idx) in doctorList" :key="idx" :data-index="idx" :data-drsid="doctor.drSid">
                            <div class="doctor-list--img">
                                <img :src="`/displayFile.do?drSid=${doctor.drSid}`" alt="이미지" onerror="this.style.display='none'">
                            </div>
                            <div class="doctor-list--con">
                                <div class="doctor-list--text">
                                    <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.emrDeptCd}`" class="doctor-list--search" target="_blank" title="새창이동"></a>
                                    <h3 class="doctor-list--name">{{ doctor.name }} 교수</h3>
                                    <p class="doctor-list--department">{{ doctor.detailField }}</p>
                                    <p class="quick-reservation" v-if="doctor.firstDate !== null">
                                        빠른예약 : {{ doctor.firstDate }} {{ doctor.timeList[0] }}
                                    </p>
                                </div>
                                <div :class="{'doctor-list--button': true, 'normalActive': selectedDoctor.drSid == doctor.drSid && !quickReservationActive, 'quickActive': selectedDoctor.drSid == doctor.drSid && quickReservationActive}">
                                    <a href="javascript:;" @click="selectDoctor(doctor)">해당 의료진 선택</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="body" v-else>
                    <div class="no-data">
                        <div class="ico">
                            <!-- 대동맥 아이콘 -->
                            <img src="@/assets/resource/icon/no-data.svg" alt="" v-if="this.$store.getters.getHostName == 'aorta'" >
                            <!-- 뇌혈관 아이콘 -->
                            <img src="@/assets/resource/icon/brain_no_data.svg" alt="" v-if="this.$store.getters.getHostName == 'ewhabrain'">
                            <!-- 엄마아기 아이콘 -->
                            <img src="@/assets/resource/icon/mom_no_data.svg" alt="" v-if="this.$store.getters.getHostName == 'mombaby'">
                            <!-- 혈액암 아이콘 -->
                            <img src="@/assets/resource/icon/blood_no_data.svg" alt="" v-if="this.$store.getters.getHostName == 'blood'">
                        </div>
                        <p>이전 단계를 먼저 선택해주세요.</p>
                    </div>
                </div>
            </div>
            <div class="step step3" ref="step03">
                <div class="top">
                    <h4>step03</h4>
                    <img src="@/assets/resource/icon/arrow_btn.svg" alt="">
                    <span>{{selectedTime.printDt || '예약일시'}}</span>
                </div>
                <div :class="{'body': true, 'active': step > 2}" v-if="step > 2">

                    <!-- v-if month-reservation -->
                    <div class="month-reservation">
                        <div class="month__wrap">
                            <div class="month__calendar type2">
                                <kr_Calendar :classList="classList" :selDate="$store.state.reserveStore.quickReserve.date" @getClass="selectDoctor" @selectDate="selectDate" />

                                <ul class="profile__tit-list">
                                    <li class="profile__tit-item">예약마감</li>
                                    <li class="profile__tit-item">예약가능</li>
                                    <li class="profile__tit-item">선택</li>
                                </ul>

                            </div>
                        </div>

                        <div class="popup-btn-wrap">
                            <!-- 선택시 active -->
                            <template v-for="(time, idx) in timeList" :key="idx">
                                <button type="button" :class="{active: selectedTime.MED_TM === time.MED_TM}" @click="setInfomation(time)" >{{ time.MED_TM }}</button>
                            </template>
                        </div>
                    </div>
                </div>
               <div class="body" v-else>
                    <div class="no-data">
                        <div class="ico">
                             <!-- 대동맥 아이콘 -->
                            <img src="@/assets/resource/icon/no-data.svg" alt="" v-if="this.$store.getters.getHostName == 'aorta'" >
                            <!-- 뇌혈관 아이콘 -->
                            <img src="@/assets/resource/icon/brain_no_data.svg" alt="" v-if="this.$store.getters.getHostName == 'ewhabrain'">
                            <!-- 엄마아기 아이콘 -->
                            <img src="@/assets/resource/icon/mom_no_data.svg" alt="" v-if="this.$store.getters.getHostName == 'mombaby'">
                            <!-- 혈액암 아이콘 -->
                            <img src="@/assets/resource/icon/blood_no_data.svg" alt="" v-if="this.$store.getters.getHostName == 'blood'">
                        </div>
                        <p>이전 단계를 먼저 선택해주세요.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="reservation__total" ref="info">
            <div class="reservation__total-info">
                <h4>예약 정보</h4>
                <div class="reservation__total-list">
                    <div class="reservation__total-item">
                        <div class="item">
                            <h5>이름</h5>
                            <p>{{ patInfo.name }}({{ patInfo.ptNo }})</p>
                        </div>
                        <div class="item">
                            <h5>생년월일</h5>
                            <p>{{ patInfo.birth }}</p>
                        </div>
                    </div>
                    <div class="reservation__total-item">
                        <div class="item">
                            <h5>소속</h5>
                            <p>{{ selectedDept.deptNm }}</p>
                        </div>
                        <div class="item">
                            <h5>의료진</h5>
                            <p>{{ selectedDoctor.name }}</p>
                        </div>
                        <div class="item">
                            <h5>예약일시</h5>
                            <p>{{ selectedTime.printDt }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="reservation__total-btn">
                <button type="button" @click="reservation">예약하기</button>
            </div>
        </div>
    </div>
    <PopupCertification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
</template>


<script>
import Calendar from '@/components/kr/common/Calendar.vue'
import PopupCertification from '@/components/kr/popup/popup_certification'

export default {
    data() {
        return {
            isMobile: false, // 모바일 여부를 체크할 변수
            popupVisible: false,
            popupShow: false,
            quickReservationActive: false,
            departmentList: [],
            viewType: 'center',
            step:1,
            selectedDept: {},
            selectedDoctor: {},
            selectedDate: {},
            selectedTime: {},
            reservationInfo: {},
            doctorList: [],
            classList: [],
            timeList: [],
            patInfo: {},
            rplFlag: 'N',           // 대리인 예약 여부
            searchKeyword: '',
            searchDoctorLayer: false,
            searchDoctorList: [],
            sortCheck: false,
            hoverDept: {},
            hoverReservationActive: false,
            width: window.innerWidth,
            step02Active: false,
            fisrtCall: false
        }
    },
    components: {
        Calendar,
        PopupCertification
    },
    async mounted() {
        this.updateMobileStatus(); // 초기 모바일 상태 확인
        window.addEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 등록
        this.setPatInfo()

        window.addEventListener("message", (event) => {
            try {

                if (event.data && event.data.source === "react-devtools-content-script") {
                    return;
                }

                const receivedData = JSON.parse(event.data); // JSON 파싱
                if (receivedData.callFunction === "checkSuccess") {
                    this.checkSuccess(receivedData.data); // 데이터 전달
                }
            } catch (e) {
                console.error("Invalid JSON data received:", e);
            }
        });

        // this.axios.get(this.api.department.list)
        //     .then(res => {
        //         // 예약여부 필수여부 확인필요
        //         // this.departmentList = res.data.deptList.filter(el => el.rsvOpenYn == 'Y')
        //         this.departmentList = res.data.deptList

        //     })
        //     .catch(err => {
        //         console.error(err)
        //     })

        const res = await this.axios.get(this.api.department.list, {params: {hospId: this.$store.getters.getHost}})
        const deptList = res.data.deptList ?? res.data;
        // this.departmentList['center'] = res.data.filter(item => item.deptCd !== 'mom04' && item.deptType == '1');
        // this.departmentList['clinic'] = res.data.filter(item => item.deptCd !== 'mom04' && item.deptType == '2');
        this.departmentList['center'] = deptList.filter(item => item.deptCd !== 'mom04' && item.deptType == '1');
        this.departmentList['clinic'] = deptList.filter(item => item.deptCd !== 'mom04' && item.deptType == '2');
        
        // 의료진 - 진료예약
        const normal = this.$store.state.reserveStore.normalReserve
        const quick = this.$store.state.reserveStore.quickReserve

        if(normal){
            try{
                this.quickReservationActive = false
                if(!normal.deptCd) normal.deptCd = normal.mainDeptCd
                if(!normal.deptNm) normal.deptNm = normal.mainDeptNm
                if(!normal.name) normal.name = normal.drName
                if(normal?.doctorDept && !normal?.doctorDept?.deptNm) normal.doctorDept.deptNm = normal.deptNm
                await this.selectDept(normal.doctorDept ? normal.doctorDept : normal)
                const doctor = this.doctorList.find(i => i.drSid === normal.drSid) || null

                if(normal.date){
                    await this.selectDoctor(doctor || normal, normal.date.slice(0, 6))
                    await this.selectDate({
                        text: normal.date
                    });
                }else{
                    await this.selectDoctor(doctor || normal)
                }

            }catch(err){
                console.error('진료예약 에러발생: ', err)
            }
        }else if(quick){
            try{
                if(!quick.deptCd) quick.deptCd = quick.mainDeptCd
                if(!quick.deptNm) quick.deptNm = quick.mainDeptNm
                if(!quick.name) quick.name = quick.drName
                if(quick?.doctorDept && !quick?.doctorDept?.deptNm) quick.doctorDept.deptNm = quick.deptNm
                await this.selectDept(quick.doctorDept ? quick.doctorDept : quick)
                const doctor = this.doctorList.find(i => i.drSid === quick.drSid) || null

                if(doctor.firstDate){
                    this.$store.state.reserveStore.quickReserve.date = doctor.firstDate.replaceAll('-', '').slice(0, 8)
                    await this.selectDoctor(doctor || quick, doctor.firstDate.replaceAll('-', '').slice(0, 6))
                    await this.selectDate({
                        text: doctor.firstDate.replaceAll('-', '')
                    });
                }else{
                    await this.selectDoctor(doctor || quick)
                }

                if(doctor.timeList){
                    await this.setInfomation({
                        MED_TM: doctor.timeList[0]
                    });
                }

                // this.quickReservationDoctor(quick)
            }catch(err){
                console.error('빠른예약 에러발생: ', err)
            }
            // try{
            //     if(!quick.deptCd) quick.deptCd = quick.mainDeptCd
            //     if(!quick.deptNm) quick.deptNm = quick.mainDeptNm
            //     if(!quick.name) quick.name = quick.drName
            //     this.quickReservation(quick.doctorDept ? quick.doctorDept : quick)
            // }catch(err){
            //     console.error('빠른예약 에러발생: ', err)
            // }
        }

    },
    methods: {
        goStep(step){
            if(this.isMobile) this.step = step
        },
        updateMobileStatus() {
            this.isMobile = window.innerWidth < 768; // 모바일 기준: 768px 이하
        },
        checkSuccess(data){
            if(data.iReturn === 0 && data.ptNo !== '' && data.ptNo !== null){
                // this.hidePopup()
                this.popupVisible = false;
                this.$store.state.myInfoStore.ptNo = data.ptNo;
                this.setPatInfo()
            }else{
                alert(data.sMessage)
            }
        },
        hidePopup() {
            this.popupVisible = false;

            //뒤로가기
            this.$router.go(-1)
        },
        hoverActive(dept, bool){
            this.hoverDept = dept
            this.hoverReservationActive = bool
        },
        setPatInfo(){
            if(this.$store.state.patInfoStore.ptNo){
                this.rplFlag = 'Y'
            }else{
                this.$store.state.patInfoStore.patName = this.$store.state.myInfoStore.name
                this.$store.state.patInfoStore.patBirth = this.$store.state.myInfoStore.birth
                this.$store.state.patInfoStore.patHpNo = this.$store.state.myInfoStore.hpNo
                this.$store.state.patInfoStore.ptNo = this.$store.state.myInfoStore.ptNo
                this.$store.state.patInfoStore.email = this.$store.state.myInfoStore.email

            }

            this.patInfo.name = this.$store.state.patInfoStore.patName
            this.patInfo.birth = this.$store.state.patInfoStore.patBirth
            this.patInfo.ptNo = this.$store.state.patInfoStore.ptNo
            this.patInfo.hpNo = this.$store.state.patInfoStore.patHpNo
            this.patInfo.email = this.$store.state.patInfoStore.email

            this.patInfo.birth = `${this.patInfo.birth.slice(0, 4)}.${this.patInfo.birth.slice(4, 6)}.${this.patInfo.birth.slice(6, 8)}`

            this.$store.commit('setNiceType', '')
            if(this.$commonUtils.isEmpty(this.patInfo.ptNo)){
                this.popupVisible = true
            }
        },
        async quickReservation(dept) {
            // 빠른 예약 시에 페이지 내 빨강색 -> 초록색 변경
            this.quickReservationActive = true
            await this.selectDept(dept)

            //빠른 진료일정인 의사를 선택
            let doctor = this.doctorList.reduce((earliest, current) => {
                if (!current.firstDate || !current.timeList || current.timeList.length === 0) {
                    return earliest;
                }

                const currentDateTime = new Date(`${current.firstDate}T${current.timeList[0]}`);

                if (!earliest.firstDate || !earliest.timeList || earliest.timeList.length === 0) {
                    return current;
                }

                const earliestDateTime = new Date(`${earliest.firstDate}T${earliest.timeList[0]}`);

                return currentDateTime < earliestDateTime ? current : earliest;
            }, {});

            await this.selectDoctor(doctor);
            if(doctor.firstDate){
                await this.selectDate({
                    text: doctor.firstDate.replaceAll('-', '')
                });
            }

            if(doctor.timeList){
                await this.setInfomation({
                    MED_TM: doctor.timeList[0]
                });
            }
        },
        async quickReservationDoctor(dept) {
            // 빠른 예약 시에 페이지 내 빨강색 -> 초록색 변경
            this.quickReservationActive = true
            await this.selectDept(dept)

            //빠른 진료일정인 의사를 선택
            //doctorList의 drSid와 doctor의 drSid가 같은 의사를 선택
            let doctor = this.doctorList.find(i => i.drSid === dept.drSid) || null

            await this.selectDoctor(doctor);
            if(doctor.firstDate){
                await this.selectDate({
                    text: doctor.firstDate.replaceAll('-', '')
                });
            }

            if(doctor.timeList){
                await this.setInfomation({
                    MED_TM: doctor.timeList[0]
                });
            }
        },
        popupBtn() {
            this.popupShow = !this.popupShow
        },
        normalReservation(dept) {
            this.quickReservationActive = false
            this.selectDept(dept)
        },
        async selectDept(dept) {
            this.timeList = []
            this.selectedTime = {}
            this.selectedDoctor = {}
            this.classList = []
            this.sortCheck = false

            const params = {
                deptCd: dept.mainDeptCd ? dept.mainDeptCd : dept.deptCd
                , emrDeptCd: dept.emrDeptCd
                , exposeYn: 'Y'
            }

            const normal = this.$store.state.reserveStore.normalReserve
            if(normal && normal.drSid && !this.fisrtCall){
                params.drSid = normal.drSid
                this.fisrtCall = true
            }
                

            const quick = this.$store.state.reserveStore.quickReserve
            if(quick && quick.drSid && !this.fisrtCall){
                params.drSid = quick.drSid
                this.fisrtCall = true
            }

            await this.axios.get(this.api.doctor.deptDoctorList,{params: params})
                .then(res => {
                    this.doctorList = res.data.doctorList

                    this.step = 2
                    this.step02Active = true

                    this.selectedDept = dept

                    // 모바일 위치 이동
                    if(this.width < 1281){
                        const step01 = this.$refs.step01
                        const rect = step01.getBoundingClientRect()
                        const offsetTop = rect.top + window.scrollY - 10
                        window.scrollTo({
                            top: offsetTop,
                            behavior: 'smooth'
                        })
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        async selectDoctorSearch(doctor){
            this.searchDoctorLayer = false

            this.step = 3
            this.step02Active = false

            //doctor.deptList 에서 deptType이 0인 것을 가져와 selectDept에 넣어준다.
            this.selectedDept = doctor.doctorDeptList.filter(el => el.deptType == 0)[0]

            this.doctorList = [ doctor ]

            this.selectDoctor(doctor)
        },
        async selectDoctor(doctor, selDt) {
            if(!doctor.drSid){
                return false
            }
            
            this.selectedDate = {}
            this.selectedTime = {}
            this.timeList = []

            if (this.selectedDoctor.drSid != doctor.drSid) {
                this.selectedDoctor = {}
                this.selectedDoctor.name = doctor.name
                this.selectedDoctor.deptCd = doctor.deptCd
                this.selectedDoctor.drSid = doctor.drSid
                this.selectedDoctor.fastDt = doctor.fastDt
                this.selectedDoctor.empId = doctor.empId
            }

            if (!selDt) {
                const today = new Date()
                const year = today.getFullYear()
                const month = ('0' + (today.getMonth() + 1)).slice(-2)

                selDt = year + month
            }

            this.axios.get(this.api.doctor.schedule,
                {
                    params: {
                        drSid: doctor.drSid,
                        IN_MED_YM: selDt,
                        deptCd: doctor.deptCd,
                    }
                })
                .then(res => {
                    this.step = 3
                    this.step02Active = false
                    this.info = res.data
                    let schedule = this.info.schedule
                    if(!doctor.deptCd && this.$store.getters.getHost == 'H0009'){
                        schedule = []
                    }

                    this.classList = []
                    if(schedule && schedule.length > 0){
                        // schedule 을 반복문으로 돌려서 classList에 넣어준다.
                        for(let i of schedule){
                            let dayClass = ''

                            if(i.CLNC_YN === 'N' && i.HOLY_YN === 'N' && i.NSP_RSN_TP_CD === 'N') {
                                if(i.MED_RSV_YN === 'N') {
                                    dayClass = 'end'
                                }else if(i.MED_RSV_YN === 'Y') {
                                    dayClass = 'possibility'
                                }
                            }

                            this.classList.push({
                                text: i.MED_DT.replaceAll('-', ''),
                                MED_RSV_YN: i.MED_RSV_YN,
                                HOLY_YN: i.HOLY_YN,
                                calClass: dayClass
                            })

                        }
                    }

                    // 모바일 위치 이동
                    // if(this.width < 1281){
                        const step02 = this.$refs.step02
                        const rect = step02.getBoundingClientRect()
                        const moHeight = this.isMobile ? 10 : 100
                        const offsetTop = rect.top + window.scrollY - moHeight
                        window.scrollTo({
                            top: offsetTop,
                            behavior: 'smooth'
                        })
                    // }

                    // 해당 의료진 스크롤 이동
                    const targetEl = document.querySelector('li[data-drsid="'+doctor.drSid+'"]');
                    const el = document.querySelector('.step2 .body')
                    if(targetEl && el && this.quickReservationActive){
                        const height = targetEl.clientHeight
                        el.scrollTo({
                            top: height,
                            behavior: 'smooth'
                        })
                    }
                })
                .catch(err => {
                    console.error(err)
                })

        },
        selectDate(date) {
            this.selectedTime = {}
            this.selectedDate = date

            this.axios.get(this.api.appointment.doctorDayTime,
                {
                    params: {
                        IN_DR_SID: this.selectedDoctor.drSid,
                        IN_MED_DT: date.text,
                        IN_MED_DEPT_CD: this.selectedDoctor.deptCd,
                    }
                })
                .then(res => {
                    this.timeList = []

                    if(res.data) {
                        this.timeList = res.data
                    }
                })
                .catch(err => {
                    console.error(err)
                })

        },
        setInfomation(time){
            this.step = 4
            const date = String(this.selectedDate.text)
            this.selectedTime = {}
            this.reservationInfo = {}

            const dt = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`

            this.selectedTime = time
            this.selectedTime.selDt = dt
            this.selectedTime.printDt = `${dt} (${ this.$commonUtils.getDayOfWeek(date)}) ${time.MED_TM}`

            this.reservationInfo.IN_MED_DT = this.selectedDate.text
            this.reservationInfo.IN_MED_TM = time.MED_TM.replace(':', '')
            this.reservationInfo.IN_DR_SID = this.selectedDoctor.drSid
            this.reservationInfo.IN_MED_DEPT_CD = this.selectedDoctor.deptCd

            setTimeout(() => {
                const element = this.$refs.info
                if(element){
                    const rect = element.getBoundingClientRect()
                    const elHeight = element.offsetHeight
                    const inHeight = innerHeight
                    const value = this.width < 1281 ? 20 : 50
                    const top = rect.top + window.scrollY - (inHeight - elHeight) + value
                    window.scrollTo({top:top, behavior: 'smooth'})
                }
            }, 600);
        },
        reservation(){
            let reservationParam = {
                "IN_MED_DEPT_CD": this.reservationInfo.IN_MED_DEPT_CD,
                "IN_MEDR_SID": this.reservationInfo.IN_DR_SID,
                "IN_MED_DT": this.reservationInfo.IN_MED_DT,
                "IN_MED_TM": this.reservationInfo.IN_MED_TM,
            }

            if(this.rplFlag == 'Y'){
                reservationParam.rplPtNo = this.patInfo.ptNo
            }

            this.axios.post(this.api.appointment.reservation, reservationParam).then(res => {
                if (res.data.code == 'error') {
                    alert(res.data.rtn_msg)

                } else {
                    alert('예약이 완료되었습니다.')

                    // 예약 완료 후 patInfoStore 초기화
                    this.$store.state.patInfoStore = {}

                    this.$store.state.reserveStore.reserve = {
                        patName: this.patInfo.name,
                        ptNo: this.patInfo.ptNo,
                        patHpNo: this.patInfo.hpNo,
                        patEmail: this.patInfo.email,
                        deptCd: this.selectedDoctor.deptCd,
                        deptName: this.selectedDept.deptNm,
                        drName: this.selectedDoctor.name,
                        drSid: this.selectedDoctor.drSid,
                        medDt: this.selectedTime.selDt,
                        medTm: this.selectedTime.MED_TM,
                        RPY_PACT_ID: res.data.result,
                        rplFlag: this.rplFlag
                    }

                    this.$router.push({path: '/kr/reserve/reservationSuccess'})


                }
            })
        },
        searchDoctor(){
            this.axios.get(this.api.appointment.doctorList, {
                params: {
                    searchKeyword: this.searchKeyword,
                    hospId: this.$store.getters.getHost
                }
            }).then(res => {
                const data = res.data

                // data가 []나, null이 아닐때만 실행
                if(data.length > 0){
                    this.searchDoctorList = res.data
                    this.searchDoctorLayer = true
                }
            })
        },
        sortOrder(type){
            if(type == 'rsvDate'){
                // 예약빠른순 firstDate와 'timeList'에 있는 가장 빠른값을 비교해서 정렬
                this.doctorList.sort((a, b) => {
                    const getEarliestDate = (doctor) => {
                        // firstDate가 null이 아니면 Date 객체로 변환
                        const firstDate = doctor.firstDate ? new Date(doctor.firstDate) : null;
                        if (!firstDate || isNaN(firstDate.getTime())) {
                            return null; // 유효하지 않은 날짜는 처리하지 않음
                        }

                        const firstTime = doctor.timeList && doctor.timeList.length > 0
                            ? doctor.timeList[0] // 시간 리스트의 첫 번째 시간을 사용
                            : null;

                        if (firstTime) {
                            const [firstHour, firstMinute] = firstTime.split(':').map(Number);
                            // 시간을 Date 객체와 결합하여 정확한 시간을 만든다.
                            const earliestTime = new Date(firstDate);
                            earliestTime.setHours(firstHour, firstMinute, 0, 0);
                            return earliestTime;
                        }

                        return firstDate; // 시간 정보가 없으면 날짜만 기준으로 처리
                    };

                    const aEarliest = getEarliestDate(a);
                    const bEarliest = getEarliestDate(b);

                    // 정렬 로직
                    if (!aEarliest && !bEarliest) {
                        return 0;
                    }
                    if (!aEarliest) {
                        return 1;
                    }
                    if (!bEarliest) {
                        return -1;
                    }

                    return aEarliest - bEarliest;
                });

            }else if(type == 'name'){
                this.doctorList.sort((a, b) => {
                    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
                })
            }
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 제거
        this.$store.commit('reserveInit')
    },
}
</script>

<style>
    .doctor-list--button.normalActive{}
    .doctor-list--button.normalActive a{color:#fff;background-color:#7D1928;}
    .doctor-list--button.quickActive a{background-color:#09847D;color:#fff;}

    /* 뇌혈관 */
    .brain .doctor-list--button.normalActive a{background-color: #4B287D;}
    .brain .doctor-list--button.normalActive a:nth-child(1):hover{background-color: #4B287D;}
    .brain .doctor-list--button.quickActive a{background-color: #C55337;}
    .brain .doctor-list--button.quickActive a:nth-child(1):hover{background-color: #C55337;}

    /* 엄마아기 */
    .mom .doctor-list--button.normalActive a{background-color:#AF3C64;}
    .mom .doctor-list--button.normalActive a:nth-child(1):hover{background-color:#AF3C64;}

    /* 혈액암병원 */
    .blood .doctor-list--button.normalActive a{background-color:#fd780f;}
    .blood .doctor-list--button.normalActive a:nth-child(1):hover{background-color:#fd780f;}
    .blood .doctor-list--button.quickActive a{background-color: #00583f;}
    .blood .doctor-list--button.quickActive a:nth-child(1):hover{background-color: #00583f;}
</style>